import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "react-auth-kit";
import News from "./component/news";
import Events from "./component/event";
import Home from "./component/body";

function App() {
  return (
    <AuthProvider
      authType={"cookie"}
      authName={"_auth"}
      cookieDomain={window.location.hostname}
      cookieSecure={window.location.protocol === "https:"}
      refresh={true}
    >
      <Router>
        <Routes>
          <Route index path="/" element={<Home />} />
          <Route path={"/news"} element={<News />} />
          <Route path={"/event"} element={<Events />} />
          <Route path="/news#fictionArea" element={<Navigate to="/" />} />
          <Route path="/event#fictionArea" element={<Navigate to="/" />} />
          <Route path="/event#articlesArea" element={<Navigate to="/" />} />
          <Route path="/event#op-edsArea" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
